export class SuggestionModel {
    id?: number;
    suggestionText?: string | undefined;
    extensionName?: string | undefined;
}
